var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvoidTollsSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H10V3c0-1.6542969-1.3457031-3-3-3H3C1.3457031,0,0,1.3457031,0,3v29h2V22h6v10h2V18h18c2.2060547,0,4-1.7939453,4-4 S30.2060547,10,28,10z M28,16h-3.6129761l1.333374-4H28c1.1025391,0,2,0.8974609,2,2S29.1025391,16,28,16z M18.3870239,16 l1.333374-4h3.8925781l-1.333374,4H18.3870239z M12.3870239,16l1.333374-4h3.8925781l-1.333374,4H12.3870239z M8,16 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2h3.6129761l-1.333374,4H8z M3,2h4c0.5517578,0,1,0.4482422,1,1v3H2V3 C2,2.4482422,2.4482422,2,3,2z M8,20H2V8h6v2c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4V20z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvoidTollsSmall);
export default __webpack_public_path__ + "static/media/avoid-tolls--small.02736ed52f61168050bb82a2461af6c9.svg";
export { ForwardRef as ReactComponent };